__turbopack_context__.v({
  "className": "instrument_serif_ecca4f09-module__opt5IG__className",
});
